import { getDataAboutSelected } from './getDataAboutSelected';


export const getDataAboutSelectedForAllSections = (state) => {
  let pos = 0;
  let postName = '';
  let hasAccess = false;

  // function l () {console.log(...arguments)}
  function l () {}

  const arr = Object.values(state)

  for (let i = arr.length - 1; i >= 0; i--) {
    const a = getDataAboutSelected(arr[i])

    if(a.pos === -1) {
      l(1, arr[i].title)
      if(arr[i + 1]) {
        const b = getDataAboutSelected(arr[i + 1])
        l(b)
        pos = 1
        postName = b.postName
        hasAccess = b.hasAccess
      } else {
        const b = getDataAboutSelected(arr[0])
        l(b)
        pos = 1
        postName = -1
        hasAccess = b.hasAccess
      }

      break
    }
  }

  if (postName !== '') return {pos, postName, hasAccess}

  for (let i = 0; i < arr.length; i++) {
    const a = getDataAboutSelected(arr[i])
    l(2, a)

    if(a.pos === -1) {
      pos = 1
      continue
    }

    pos = a.pos
    postName = a.postName
    hasAccess = a.hasAccess
    break
  }


    return {pos, postName, hasAccess}
}
